// Js for menu hover bg effect 

document.querySelector('.header__inline-menu').addEventListener('mouseenter', () => {
    document.querySelector('sticky-header').classList.add('transparent-none');
});

document.querySelector('header').addEventListener('mouseleave', () => {
    document.querySelector('sticky-header').classList.remove('transparent-none');
  
});

document.addEventListener("DOMContentLoaded", function () {
    let loading = false;
    if(document.querySelector("#next-page-link") === null){// change 28-07-25
      return false;
    }
    window.nextPageUrl = document.querySelector("#next-page-link").getAttribute("href");
    let currentPage = 1;
    let swiperInstances = [];
    function isCollectionPage() {
        return window.location.pathname.includes("/collections/");
    }
    function updateURL(page) {
        if (!isCollectionPage()) return;
        const url = new URL(window.location);
        url.searchParams.set("page", page);
        window.history.replaceState({}, "", url);
    }
    function initAllSwipers() {
        swiperInstances.forEach(s => s.destroy(true, true));
        swiperInstances = [];
        document.querySelectorAll(".swiper-container").forEach(container => {
            const swiper = new Swiper(container, {
                loop: true,
                navigation: {
                    nextEl: container.querySelector(".swiper-button-next"),
                    prevEl: container.querySelector(".swiper-button-prev"),
                }
            });
            swiperInstances.push(swiper);
        });
    }
    function loadMoreProducts() {
        if (!nextPageUrl || loading) return;
        loading = true;
        document.getElementById("loading").style.display = "block";
        fetch(nextPageUrl)
            .then(response => response.text())
            .then(data => {
                let parser = new DOMParser();
                let doc = parser.parseFromString(data, "text/html");
                let newProductsHTML = doc.querySelector("#product-grid").innerHTML;
                let nextButton = doc.querySelector("#next-page-link");
                document.querySelector("#product-grid").insertAdjacentHTML("beforeend", newProductsHTML);
                nextPageUrl = nextButton ? nextButton.getAttribute("href") : null;
                // added code 17-04-25
                
                if(nextPageUrl != null){
                  nextPageUrl = nextPageUrl.replace("q=%2A","q="+ $(".q_id").val())
                }
                // added code 17-04-25
                currentPage++;
                //updateURL(currentPage); // change 29-07-25
                initAllSwipers(); 
                document.getElementById("loading").style.display = "none";
                loading = false;
            })
            .catch(error => {
                console.error("Error loading more products:", error);
                document.getElementById("loading").style.display = "none";
                loading = false;
            });
    }
    window.addEventListener("scroll", function () {
        let scrollPosition = window.innerHeight + window.scrollY;
        let pageHeight = document.body.offsetHeight;

        if (scrollPosition >= pageHeight - 200) {
            loadMoreProducts();
        }
    });
    if (isCollectionPage()) {
        //updateURL(currentPage);// change 29-07-25
    }

    initAllSwipers(); 
});


const closeBtn = document.querySelectorAll(".close-btn");
if(closeBtn){
closeBtn.forEach((item)=>{
  item.addEventListener("click",function(e){
 e.stopPropagation();
   item.closest('.variant-size-popup-container').classList.add("hidden") 
})
})
}

// //cart-drawer Add to cart------------------->
// function addTocart(event) {
//   const button = event.currentTarget; 
//   const cartData = document.querySelector("cart-drawer");
//   const productId = button.getAttribute("productId"); 
//   const formData = {
//     id: productId,
//     quantity: 1,
//      sections:cartData.getSectionsToRender().map((section)=>section.id)
//   };
//   addProduct(formData);
// }

// function addProduct(formData) {
//   fetch("/cart/add.js", {
//     method: "POST",
//     headers: {
//       "Content-Type": "application/json",
//     },
//     body: JSON.stringify(formData),
//   })
//     .then((response) => response.json())
//     .then((data) => {
//       const cartData = document.querySelector("cart-drawer");
//       if (cartData && cartData.renderContents) {
//         cartData.renderContents(data);
//         cartShareBtn();
//       }
//     })
//     .catch((error) => console.error("Error adding product:", error));
// }

// <----------------------Add to cart functionality PDP------------------------>
function scrollToVariantSection() {
  const errorContainer = document.querySelector('.error-size')
  errorContainer.classList.remove("hidden")
  const variantSection = document.querySelector('.product__info-container');
  if (variantSection) {
    variantSection.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
  }
}

document.querySelectorAll(".size-btn").forEach(btn => {
  btn.addEventListener("click", function () {
    const variantId = this.getAttribute("data-variant-id");
    const selectedSize = this.innerText.trim();
const prevSelected = document.querySelector('.size-btn.increaseweight');

  if (prevSelected && prevSelected !== btn) {
    prevSelected.classList.remove('increaseweight');
  }
  btn.classList.add('increaseweight');
    
    // Add variantId to buttons
    document.getElementById("custom-sticky-atc")?.setAttribute("variantid", variantId);
 const buyBtn =   document.querySelector(".buy_btn_sticky button")
  buyBtn?.setAttribute("variantid", variantId);
    buyBtn?.setAttribute("data-size", selectedSize);

    // Optional: Show selected size message
    document.querySelector(".error-size")?.classList.add("hidden");
    const variantInputs = document.querySelectorAll("variant-selects input");
  variantInputs.forEach((item) => {
    if(selectedSize===item.value){
        const itemId = item.id; 
        const label = document.querySelector(`label[for="${itemId}"]`);
        if (label) {
            label.click(); 
        }
      }
  });
  });
});
const stickyAtc = document.getElementById("custom-sticky-atc");
if(stickyAtc){
stickyAtc.addEventListener("click", function () {
  const variantId = this.getAttribute("variantid");
  const el = document.querySelector(`.size-btn[data-variant-id="${variantId}"]`);

  if (!variantId || !el) {
    document.querySelector(".error-size").classList.remove("hidden");
    scrollToVariantSection();
    return;
  }
  // change 29-07-25
  $(".atc_btn_sticky .loading__spinner").removeClass("hidden");
  $(".atc_btn_sticky .add-to-cart-custom").addClass("hidden");
  $(".product-form__submit").trigger("click");
  setTimeout(function() {
    $(".atc_btn_sticky .add-to-cart-custom").removeClass("hidden");
    $(".atc_btn_sticky .loading__spinner").addClass("hidden");
  }, 2500);
  //addToCart(variantId, el); 
});
}

const buyNowButton = document.querySelector(".buy_btn_sticky button")
if(buyNowButton){
buyNowButton.addEventListener("click", function () {
  const variantId = this.getAttribute("variantid");
const dataSize = this.getAttribute("data-size")
  console.log(dataSize,"data")
  if (!variantId) {
    document.querySelector(".error-size").classList.remove("hidden");
    scrollToVariantSection();
    return;
  }
onBuyNowClick()
});
}


  function addToCart(variantId, el) {
  const cartData = document.querySelector("cart-drawer");
  document.querySelector(".error-size").classList.add("hidden");
  var qty = document.querySelector(".product__info-container .quantity__input").value;
    console.log(qty);
  if(!qty){qty=1}

  const selectedSize = el.innerText.trim();
  

  const sectionsToRender = cartData?.getSectionsToRender?.().map(section => section.id) || [];

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: variantId, quantity: qty, sections: sectionsToRender })
  })
    .then(response => response.json())
    .then(data => {
      if (cartData && cartData.classList.contains("is-empty")) {
        cartData.classList.remove("is-empty");
      }

      // Update cart drawer
      fetch('/cart')
        .then(response => response.text())
        .then(html => {
          let parser = new DOMParser();
          let doc = parser.parseFromString(html, 'text/html');
          let newCartDrawer = doc.querySelector('.cart-drawer');
          if (newCartDrawer) {
            document.querySelector('.cart-drawer').innerHTML = newCartDrawer.innerHTML;
            cartShareBtn("custom1 add to cart");
          }
        });

      // Update cart bubble
      fetch(window.location.pathname + '?sections=cart-icon-bubble')
        .then(response => response.json())
        .then(sectionData => {
          const cartBubble = document.querySelector('[id^="cart-icon-bubble"]');
          if (cartBubble) {
            cartBubble.innerHTML = sectionData['cart-icon-bubble'];
          }
        });

      // Show temporary confirmation
      const stickyButton = document.getElementById("sticky-cart-button");
      const showMsg = document.querySelector(".show-added-msg");

      if (stickyButton) stickyButton.classList.add('hidden');
      if (showMsg) {
        showMsg.classList.remove("hidden");
        showMsg.innerHTML = `<span>Size ${selectedSize} added to your bag</span>`;
        setTimeout(() => {
          if (stickyButton) stickyButton.classList.remove('hidden');
          showMsg.classList.add("hidden");
        }, 2000);
      }
    })
    .catch(error => console.error('Error adding to cart:', error));
}
document.addEventListener("DOMContentLoaded", function () {
  const removeChecked = document.querySelectorAll("variant-selects input[type='radio']");
  
  removeChecked.forEach((item) => {
    if (item.checked) {
      item.removeAttribute("checked"); 
    }
  });
});